import { call, fork, put } from 'redux-saga/effects';
import { photoCaptureUpdateAttachmentsFailureAction, photoCaptureUpdateAttachmentsSuccessAction, showIntelligentPhotoCaptureToastAction } from '../actions';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
import { PhotoCaptureContextService } from '../services';
import { intelligentPhotoCaptureFailureLoggingSaga } from './intelligentPhotoCaptureFailureLoggingSaga';
export function* photoCapturePatchUpdateAttachmentSaga(action) {
    var _a;
    const { attachmentRequest, contextId, coCode, iterationId } = action.payload;
    const sanitizedAttachmentInfo = attachmentRequest.attachmentInfo;
    try {
        const photoCaptureContextService = new PhotoCaptureContextService();
        const requestPayload = Object.assign(Object.assign({}, (((_a = attachmentRequest.deleteAttachmentInfo) === null || _a === void 0 ? void 0 : _a.length) && {
            deleteAttachmentInfo: attachmentRequest.deleteAttachmentInfo
        })), ((sanitizedAttachmentInfo === null || sanitizedAttachmentInfo === void 0 ? void 0 : sanitizedAttachmentInfo.length) && { attachmentInfo: sanitizedAttachmentInfo }));
        yield call({
            context: photoCaptureContextService,
            fn: photoCaptureContextService.photoCapturePatchUpdateAttachmentContextData
        }, requestPayload, contextId, coCode);
        yield put(photoCaptureUpdateAttachmentsSuccessAction(attachmentRequest.deleteAttachmentInfo, sanitizedAttachmentInfo || [], iterationId));
        if (attachmentRequest.operationType) {
            yield put(showIntelligentPhotoCaptureToastAction(attachmentRequest.operationType));
        }
    }
    catch (error) {
        yield put(photoCaptureUpdateAttachmentsFailureAction(attachmentRequest.deleteAttachmentInfo, sanitizedAttachmentInfo || [], iterationId));
        // Fire-and-forget error logging so catch-path handling is not blocked.
        yield fork(intelligentPhotoCaptureFailureLoggingSaga, {
            actionType: action.type,
            response: error,
            requestedPayload: action.payload,
            companyCode: action.payload.coCode,
            errorDetail: getErrorMessagesBasedOnStatusCode(error)
        });
    }
}
//# sourceMappingURL=photoCapturePatchUpdateAttachmentSaga.js.map